import { observer } from 'mobx-react-lite'
import OAuthClientStore, { OAuthClientStoreProvider, useOAuthClientStore } from './OAuthClientStore'
import useStore from 'reusable/mobx-store-utils'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import GapDataGrid from 'reusable/mui/data-grid/GapDataGrid'
import OAuthClientConfig from './OAuthClientConfig'
import GapAlert from 'reusable/mui/alert/GapAlert'

export default observer(function OAuthClientList() {
   const oAuthClientStore = useStore(() => new OAuthClientStore({}))

   return (
      <OAuthClientStoreProvider store={oAuthClientStore}>
         <OAuthClientListContent />
      </OAuthClientStoreProvider>
   )
})

const OAuthClientListContent = observer(function OAuthClientListContent() {
   const oAuthClientStore = useOAuthClientStore()

   return (
      <Box>
         <Typography variant="h4" sx={{ mb: 3 }}>
            OAuth Client Management
         </Typography>

         <GapAlert severity="info" variant="standard" sx={{ mb: 3 }}>
            Manage OAuth clients for 3rd party integrations like Circle, Zoho, etc. View configuration details to copy/paste into external systems.
         </GapAlert>

         <GapDataGrid
            columns={oAuthClientStore.gridColumns}
            rows={oAuthClientStore.clients}
            loading={oAuthClientStore.isLoading}
            noRowsText="No OAuth clients configured"
            onCellClick={oAuthClientStore.onCellClickHandler}
            getRowId={oAuthClientStore.getRowId}
         />

         <OAuthClientConfig />
      </Box>
   )
})
